import { ISolicitudDocumentoModel } from "../../interfaces/solicitud/documento/ISolicitudDocumentModel";
import { ISolicitudPersonaModel } from "../../interfaces/solicitud/ISolicitudPersonaModel";
import { ISolicitudPersonalAsignarDocumentoModel } from "../../interfaces/solicitud/personal/ISolicitudPersonalAsignarDocumentoModel";

export class SolicitudPersonalAsignarDocumentoModel implements ISolicitudPersonalAsignarDocumentoModel {
    personas: ISolicitudPersonaModel[];
    documento?: ISolicitudDocumentoModel;

    constructor(){
        this.personas = new Array<ISolicitudPersonaModel>();
    }
}